<template lang="pug">

  .sosSelectWrapper

    label.sosSelectTitle
      span(v-if="labelDescription" v-html="`${label} <span class=\"vLabelDescription\">${labelDescription}</span>`")
      span(v-else v-html="`${label}`")

    .sosSelectField

      .sosSelect(ref="sosHourSelect" @mousedown="hourMouseDownEvent => openHour(hourMouseDownEvent, 'auto')" :class="{ 'sosSelect--showing': showingHour, 'sosSelect--disabled': disabled }" tabindex="0")
        .sosSelectSelected {{ selectedHourText }}
        .sosSelectOptions(:class="{ 'sosSelectOptions--show': showingHour }")
          .sosSelectOption(v-if="hours.length > 0" v-for="(itemHour, itemHourIndex) in hours" :key="`sos-select-item-${itemHour.key}`" @click="onHourSelect(itemHourIndex)" :class="{ 'sosSelectOption--selected': selectedHourValue === itemHour.value, 'sosSelectOption--first': itemHourIndex === 0 }")
            | {{ itemHour.text || '&nbsp;' }}

      .sosSelectDivider {{ ':' }}

      .sosSelect(ref="sosMinuteSelect" @mousedown="minuteMouseDownEvent => openMinute(minuteMouseDownEvent, 'auto')" :class="{ 'sosSelect--showing': showingMinute, 'sosSelect--disabled': disabled }" tabindex="0")
        .sosSelectSelected {{ selectedMinuteText }}
        .sosSelectOptions(:class="{ 'sosSelectOptions--show': showingMinute }")
          .sosSelectOption(v-if="minutes.length > 0" v-for="(itemMinute, itemMinuteIndex) in minutes" :key="`sos-select-item-${itemMinute.key}`" @click="onMinuteSelect(itemMinuteIndex)" :class="{ 'sosSelectOption--selected': selectedMinuteValue === itemMinute.value, 'sosSelectOption--first': itemMinuteIndex === 0 }")
            | {{ itemMinute.text || '&nbsp;' }}

</template>

<script>

  export default {
    name: 'SosTimeSelect',

    props: {
      label: { type: String, required: true },
      hours: { type: Array, required: true },
      minutes: { type: Array, required: true },
      // items: { type: Array, required: true },

      disabled: { type: Boolean, default: () => false },
      labelDescription: { type: String, default: () => '' },
      default: { type: Object, default: () => ({ hour: '', minute: '00' }) },
    },

    data ()
    {
      return {
        showingHour: false,
        showingMinute: false,
        selectedHourValue: '',
        selectedHourText: 'Horas',
        selectedMinuteValue: '',
        selectedMinuteText: 'Minutos',
      }
    },

    watch: {
      default: {
        immediate: true,
        handler (defaultNew, defaultOld) {
          // [24/01/25] console.log('::: SosTimeSelect > WATCH:', typeof defaultOld === 'object' ? { ...defaultOld } : defaultOld, typeof defaultNew === 'object' ? { ...defaultNew } : defaultNew)

          if (typeof defaultNew === 'object') {
            this.default = defaultNew
            this.refreshProps()
          }
        },
      },
    },

    mounted () {
      // console.log('::: SosTimeSelect[mounted]:', this.hours, this.minutes)

      this.refreshProps()

      document.addEventListener('mousedown', this.close)
    },

    beforeDestroy () {
      document.removeEventListener('mousedown', this.close)
    },

    methods: {
      openHour (event, status)
      {
        if (this.disabled) return

        if (event.which === 3) return // SENHOR JESUS

        if (status === 'auto')
        {
          if (this.showingHour) {
            /* this.showingHour = false */
          } else {
            this.showingHour = true
          }
        }
        else
        {
          this.showingHour = status
        }
      },

      openMinute (event, status)
      {
        if (this.disabled) return false

        if (event.which === 3) return false // SENHOR JESUS

        if (status === 'auto')
        {
          if (this.showingMinute) {
            /* this.showingMinute = false */
          } else {
            this.showingMinute = true
          }
        }
        else
        {
          this.showingMinute = status
        }
      },

      close (event) {
        if (!this.$refs.sosHourSelect.contains(event.target)) this.showingHour = false
        if (!this.$refs.sosMinuteSelect.contains(event.target)) this.showingMinute = false
      },

      refreshProps ()
      {
        const getHour = this.default.hour.length > 0 ? this.hours.find(hourItem => this.default.hour === hourItem.value) : false
        const getMinute = this.default.minute.length > 0 ? this.minutes.find(minuteItem => this.default.minute === minuteItem.value) : false

        this.selectedHourValue = getHour && getHour.value ? getHour.value : ''
        this.selectedHourText = getHour && getHour.text ? getHour.text : 'Horas'

        this.selectedMinuteValue = getMinute && getMinute.value ? getMinute.value : ''
        this.selectedMinuteText = getMinute && getMinute.text ? getMinute.text : 'Minutos'
      },

      onHourSelect (itemIndex)
      {
        this.showingHour = false

        const hourItem = this.hours[itemIndex] || null

        const hourChanged = !!hourItem === true && !!hourItem.value === true && hourItem.value !== this.selectedHourValue

        if (hourChanged) {
          this.$emit('sosSelectChanged', { hour: hourItem.value, minute: this.selectedMinuteValue })
        }
      },

      onMinuteSelect (itemIndex)
      {
        this.showingMinute = false

        const minuteItem = this.minutes[itemIndex] || null
        const minuteChanged = !!minuteItem === true && !!minuteItem.value === true && minuteItem.value !== this.selectedMinuteValue

        if (minuteChanged) {
          this.$emit('sosSelectChanged', { hour: this.selectedHourValue, minute: minuteItem.value })
        }
      },
    },
  }

</script>
